import PropTypes from "prop-types";
import React from "react";

function WelcomeStep({ termsAccepted, setTermsAccepted, nextStep }) {
    const handleNext = () => {
        if(!termsAccepted) {
            return;
        }
        nextStep();
    };

    return (
        <div className="w-full max-w-4xl px-4 pt-8 pb-4">
            <div className="flex flex-col items-center justify-between gap-8 lg:flex-row">
                {/* Left side - Content */}
                <div className="w-full lg:w-1/2">
                    <div className="mb-6">
                        <h1 className="text-3xl md:text-4xl font-bold text-navy mb-4">
                            Let&apos;s set up your investor account
                        </h1>
                    </div>

                    <div className="mb-6 space-y-3 text-gray-600">
                        <p>
                            By continuing, you agree to the{" "}
                            <a
                                href="/docs/terms_of_use_10_2026.pdf"
                                target="_blank"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Terms and Conditions
                            </a>
                            ,{" "}
                            <a
                                href="/docs/privacy_policy_10_2026.pdf"
                                target="_blank"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Privacy Policy
                            </a>
                            ,{" "}
                            <a
                                href="/docs/investor_agreement_05_2026.pdf"
                                target="_blank"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Investor Agreement
                            </a>
                            , 
                            <a
                                href="/docs/electronic_delivery_of_documents_11_2025.pdf"
                                target="_blank"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Electronic Delivery of Documents
                            </a>
                            , and{" "}
                            <a
                                href="/docs/electronic_funds_transfers_03_2026.pdf"
                                target="_blank"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Electronic Funds Transfers
                            </a>
                            .
                        </p>
                    </div>

                    <div className="mb-8">
                        <p className="text-gray-600">
                            Are you a founder raising money?
                            <br />
                            <a
                                href="/sign-up"
                                className="text-navy underline hover:text-navy-2"
                            >
                                Start a campaign
                            </a>{" "}
                            instead.
                        </p>
                    </div>

                    {/* Terms acceptance checkbox */}
                    <div className="mb-8">
                        <label className="flex items-start space-x-3 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={termsAccepted}
                                onChange={(e) =>
                                    setTermsAccepted(e.target.checked)
                                }
                                className="mt-1 h-4 w-4 text-navy focus:ring-navy border-gray-300 rounded"
                            />
                            <span className="text-sm text-gray-700">
                                I agree to the terms and conditions listed above
                            </span>
                        </label>
                    </div>
                </div>

                {/* Right side - Illustration */}
                <div className="flex justify-center w-full lg:w-1/2">
                    <div className="relative overflow-hidden rounded-lg w-80 h-60 bg-gradient-to-br from-teal-200 via-blue-200 to-blue-400">
                        {/* Simple ship illustration */}
                        <div className="absolute transform -translate-x-1/2 bottom-20 left-1/2">
                            {/* Ship body */}
                            <div className="relative w-16 h-8 rounded-b-lg bg-amber-800">
                                {/* Masts */}
                                <div className="absolute w-1 h-12 -top-12 left-2 bg-amber-900"></div>
                                <div className="absolute w-1 h-16 -top-16 left-6 bg-amber-900"></div>
                                <div className="absolute w-1 -top-14 left-10 h-14 bg-amber-900"></div>

                                {/* Sails */}
                                <div className="absolute left-0 w-4 h-8 bg-gray-100 rounded-r -top-11"></div>
                                <div className="absolute w-6 h-12 bg-gray-100 rounded-r -top-15 left-4"></div>
                                <div className="absolute w-5 h-10 bg-gray-100 rounded-r -top-13 left-8"></div>
                            </div>
                        </div>

                        {/* Island */}
                        <div className="absolute bottom-0 w-20 h-16 bg-green-500 rounded-t-full left-4">
                            {/* Palm tree */}
                            <div className="absolute top-2 right-4">
                                <div className="w-1 h-8 bg-amber-900"></div>
                                <div className="absolute w-6 h-4 bg-green-600 rounded-full -top-2 -left-2"></div>
                            </div>
                        </div>

                        {/* Waves */}
                        <div className="absolute bottom-0 w-full h-8 bg-blue-400 opacity-70">
                            <div className="w-full h-2 bg-blue-300 animate-pulse"></div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Navigation */}
            <div className="flex justify-end mt-8">
                <button
                    onClick={handleNext}
                    disabled={!termsAccepted}
                    className={`px-8 py-3 rounded-lg font-semibold transition-all ${
                        termsAccepted
                            ? "bg-navy text-white hover:bg-navy-2 shadow-lg"
                            : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

WelcomeStep.propTypes = {
    termsAccepted: PropTypes.bool.isRequired,
    setTermsAccepted: PropTypes.func.isRequired,
    nextStep: PropTypes.func.isRequired,
};

export default WelcomeStep;
